import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

import letterImage from '../images/letter.png';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Body = styled(T.Body3)`
  margin-block-end: 16px;
`;

const StyledImage = styled.img`
  width: 170px;
  height: 170px;
  margin-block: 60px;
  margin-inline: auto;
`;

const ApplicationSentSSMOView = () => {
  return (
    <Wrapper>
      <T.Heading5>
        <FormattedMessage id="self-serve-sign-up.application-sent.from-email-header" />
      </T.Heading5>
      <StyledImage src={letterImage} />
      <Body>
        <FormattedMessage id="self-serve-sign-up.application-sent.from-email-ssmo-text" />
      </Body>
    </Wrapper>
  );
};

export default ApplicationSentSSMOView;
